export default __webpack_public_path__ + "static/media/themes.d50922bc.png";